<template>
  <div class="postSummary">
      <div class="post__header articleHeading">
          <span>{{post.title}}</span>
      </div>
      <div class="post_authorDetails">
          <div>
            <Avatar :src="post.author.avatar_URL" />
          </div>
          <div class="post_authorGrid">
              <div class="post_authorName">
                  <span>{{post.author.name}}</span>
              </div>
              <div class="post_date">
                  <span>{{getReadableDate(post.modified)}}</span>
              </div>
          </div>
      </div>
      <div class="post_content">
          <span v-html="post.content"></span>
      </div>
  </div>
</template>

<script>
export default {
  name: 'PostSummary',
  props: {
        post:Object,
    },
    methods:{
        getReadableDate(date){
            var dateEditedAt = new Date(date);
            return dateEditedAt.toDateString();
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.articleHeading{
  font-family: 'Outfit', sans-serif;
  font-weight: 600;
  color: #504f4f;
}
.post_authorDetails{
    padding: 20px 0px 20px 0px;
    display: flex;
}
.post_authorName{
    font-size:16px;
}
.post_authorGrid{
    padding-left: 10px;

}
.post_date{
    font-size:12px;
    color:#a8adb1;
}


@media only screen and (max-width: 600px) {

.articleHeading{
  font-size: 1.2rem;
  padding: 13px;
  text-align: center;
}
.postSummary{
    margin-left: 9%;
    margin-right: 9%;
    margin-top: 2%;
}
}
@media screen and (min-width: 768px) { 

.articleHeading{
  font-size: 3vw;
}

.postSummary{
    margin-left: 20%;
    margin-right: 20%;
    margin-top: 1%;
}
}
</style>

<style>
.post_content img{
    object-fit:initial;
    width: 100%;
    height: 100%;
    position: relative;
}
</style>